import { Link } from 'react-router-dom';

const footerLinks = {
  games: {
    title: '游戏中心',
    links: [
      { label: '真人娱乐', path: '/category?tab=live' },
      { label: '老虎机', path: '/category?tab=slot' },
      { label: '体育竞猜', path: '/category?tab=sports' },
      { label: '彩票', path: '/category?tab=lottery' },
      { label: '棋牌', path: '/category?tab=card' },
    ],
  },
  info: {
    title: '最新资讯',
    links: [
      { label: '行业资讯', path: '/articles' },
      { label: '游戏攻略', path: '/articles' },
      { label: '优惠活动', path: '/articles' },
      { label: '平台动态', path: '/articles' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '信誉保障', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '常见问题', path: '/#faq' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-xl font-heading font-bold text-primary-400 mb-4">
              新葡京娱乐城
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              顶级在线娱乐平台，提供真人百家乐、老虎机、体育竞猜等多元游戏。安全可靠、存取款便捷、24小时客服在线。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-medium text-background-100 mb-4 whitespace-nowrap">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 新葡京娱乐城 版权所有 | 请理性娱乐，享受健康生活
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">责任博彩</a>
          </div>
        </div>
      </div>
    </footer>
  );
}